export enum AdherenceState {
    pending,
    accepted,
    rejected
}


